module.exports = __webpack_public_path__ + "images/bg1.ce6f2bd.jpg";